<template>
  <div id="content-profile">
    <transition name="fade" mode="out-in">
      <Loader v-if="loading" key="loader" />
      <Error v-else-if="error" key="error" />
      <div v-else class="content" key="profile">
        <Player @showQuizModal="showQuizModal" :standard="standard" />
        <div class="ui basic padded container segment">
          <Tip v-if="tip" v-bind="tip" :standard="standard" />
          <div class="ui fitted basic segment">
            <button
              v-if="showTakeQuizButton"
              class="ui mobile hidden green button right floated"
              @click="showQuizModal"
            >Take Quiz</button>
            <h2>{{ profile.title }}</h2>
            <button
              v-if="showTakeQuizButton"
              class="ui mobile only green button"
              @click="showQuizModal"
            >Take Quiz
            </button>
          </div>
          <SupportMaterials :syncguid="syncguid" />
          <div class="ui horizontally fitted basic segment">
            <p>
              <span class="ui italic text">{{ durationText }}</span>
            </p>
            <div v-html="profile.description" />
          </div>
          <Outline :syncguid="syncguid" :standard="standard" />
          <Resources :syncguid="syncguid" />
        </div>
      </div>
    </transition>
    <QuizModal ref="quizModal" v-if="hasQuiz" />
  </div>
</template>

<script>
import Error from '@/components/shared/Error';
import Loader from '@/components/shared/Loader';
import Outline from '@/components/profile/Outline';
import Player from '@/components/profile/Player';
import SupportMaterials from '@/components/profile/SupportMaterials';
import Resources from '@/components/profile/Resources';
import QuizModal from '@/components/quiz/Modal';
import Tip from '@/components/interactions/views/Tip';

import SessionService from '@/services/api/session/session-service';
import { mapGetters } from 'vuex';

export default {
  name: 'ContentProfile',
  components: {
    Error,
    Loader,
    Outline,
    Player,
    SupportMaterials,
    Resources,
    QuizModal,
    Tip,
  },
  computed: {
    ...mapGetters({
      loading: 'loadingProfile',
      error: 'error',
      tip: 'video/tip',
    }),
    syncguid() {
      return this.$route.params.syncguid;
    },
    profile() {
      return !this.loading
        ? this.$store.getters.contentById(this.syncguid).profile
        : {};
    },
    quiz() {
      return !this.loading
        ? this.$store.getters.contentById(this.syncguid).quiz
        : {};
    },
    durationText() {
      if (this.profile === {}) {
        return '';
      }
      const min = this.profile.duration === 1 ? 'minute' : 'minutes';
      return `Duration: ${this.profile.duration} ${min}`;
    },
    disableScrubbing() {
      return this.profile.disableScrubbing;
    },
    hasQuiz() {
      return Object.keys(this.quiz).length > 0;
    },
    showTakeQuizButton() {
      if (this.disableScrubbing) {
        return this.hasQuiz && this.$store.getters['video/endOfVideo'];
      }
      return this.hasQuiz && this.$store.getters['video/timeInCourse'] >= 60;
    },
    standard() {
      return this.$route.params.standard;
    },
  },
  methods: {
    showQuizModal() {
      this.$refs.quizModal.showModal();
    },
    initProgress() {
      switch (this.standard) {
        case 'AICC':
          return SessionService.getProgress(this.standard).then(res => {
            if (!res.Core_Lesson) {
              const body = {
                code: this.syncguid,
                time: 0,
                score: 0,
                status: 'i',
                watchUntilEnd: false,
                endOfVideo: false,
                videoPosition: 0,
                maxVideoPosition: 0,
              };
              return SessionService.saveProgress(body, this.standard);
            }
          });
        case 'SCORM_12':
        case 'SCORM_2004':
          // eslint-disable-next-line
          please.init(window);
          // eslint-disable-next-line
          return please(window.opener)
            .call('handleScormMessage', '{ "messageType": "start" }')
            .then(d => {
              if (d !== null) {
                // eslint-disable-next-line
                please(window.opener)
                  .call('handleScormMessage', '{ "messageType": "get_suspend_data" }')
                  .then(d => {
                    if (d !== null) {
                      const res = JSON.parse(d);
                      if (!res.s || res.s === '') {
                        const body = {
                          c: this.syncguid,
                          s: 'in-progress',
                          qs: null,
                          we: false,
                          ev: false,
                          vp: 0,
                          mp: 0,
                          ps: [],
                        };
                        const msg = {
                          messageType: 'save_suspend_data',
                          data: body,
                          score: body.qs,
                          seconds: body.vp,
                        };
                        // eslint-disable-next-line
                        return please(window.opener)
                          .call('handleScormMessage', JSON.stringify(msg));
                      }
                    }
                  });
              }
            });
      }
    },
  },
  watch: {
    profile: function(newProfile, oldProfile) {
      document.title = newProfile.title;
    },
  },
  mounted() {
    this
      .initProgress()
      .then(() => this.$store.dispatch('loadProfile', this.syncguid));
  },
};
</script>

<style lang="less" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
h2.ui.header {
  margin-top: 0;
}
</style>
